export default {"src":"/_next/static/media/inspection.432fa8ea.svg","height":69,"width":69,"blurWidth":0,"blurHeight":0};